<div class="grid gap-2 mb-4">
  <dl class="grid grid-cols-3">
      <dt i18n="@@createFiscal_step3_accounting_type">Accounting type</dt>
      <dd class="col-span-2">{{fiscal.providerName}}</dd>
  </dl>
  <dl class="grid grid-cols-3">
      <dt i18n="@@createFiscal_step3_cvr_number">CVR/ORG number</dt>
      <dd class="col-span-2">{{fiscal.orgNumber}}</dd>
      <dd class="col-start-2 col-end-4">
        <span *ngIf="fiscal.registeredForVat" i18n="@@createFiscal_step3_has_vat">VAT registered</span>
        <span *ngIf="!fiscal.registeredForVat" i18n="@@createFiscal_step3_does_NOT_has_vat">Not VAT registered</span>
      </dd>
  </dl>
  <dl class="grid grid-cols-3">
      <dt i18n="@@createFiscal_step3_company">Company</dt>
      <dd class="col-span-2">{{fiscal.address.name}}</dd>
  </dl>
  <dl class="grid grid-cols-3">
      <dt i18n="@@createFiscal_step3_address">Address</dt>
      <dd class="col-span-2">
          <address>{{fiscal.address.street}}<br>
              {{fiscal.address.placeName}}<br *ngIf="fiscal.address.placeName">
              {{fiscal.address.zip}} {{fiscal.address.city}}<br>
              {{fiscal.address.countryDisplayName}}</address>
      </dd>
  </dl>
  <dl class="grid grid-cols-3">
      <dt i18n="@@createFiscal_step3_phone_number">Phone number</dt>
      <dd class="col-span-2">{{fiscal.phone}}</dd>
  </dl>
  <dl class="grid grid-cols-3">
      <dt i18n="@@createFiscal_step3_email">Email</dt>
      <dd class="col-span-2">{{fiscal.email}}</dd>
  </dl>
  <dl class="grid grid-cols-3">
      <dt i18n="@@createFiscal_step3_currency">Currency</dt>
      <dd class="col-span-2">{{fiscal.currencyDescription}}</dd>
  </dl>
  <dl class="grid grid-cols-3">
      <dt i18n="@@createFiscal_step3_culture">Language</dt>
      <dd class="col-span-2">{{fiscal.cultureDisplayName}}</dd>
  </dl>
</div>
